var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('create-content-layout',{attrs:{"title":'ویرایش محتوا',"submitFunction":_vm.UpdateContent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }